import type { SVGProps } from 'react';

/**
 * Inline icon set. Activities run under a strict CSP behind Discord's proxy,
 * so no icon font or external sprite: everything ships in the bundle.
 */
const PATHS = {
  home: 'M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5M9.5 20v-6h5v6',
  gamepad:
    'M7 12H3.5m1.75-1.75v3.5M15.5 11.5h.01M18 14h.01M8.5 6.5h7a5.5 5.5 0 0 1 5.4 6.5l-.6 3.3A3 3 0 0 1 15.4 18l-.9-1.5h-5L8.6 18a3 3 0 0 1-4.9-1.7l-.6-3.3A5.5 5.5 0 0 1 8.5 6.5Z',
  wheel:
    'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 0v9m0 0 6.4 6.4M12 12l-8.5 2.5M12 12l8.5 2.5M12 12 5.6 5.6',
  coins:
    'M12 7c4.4 0 8-1.1 8-2.5S16.4 2 12 2 4 3.1 4 4.5 7.6 7 12 7Zm8-2.5v6c0 1.4-3.6 2.5-8 2.5s-8-1.1-8-2.5v-6m16 6v6c0 1.4-3.6 2.5-8 2.5s-8-1.1-8-2.5v-6',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7.5 8a7.5 7.5 0 0 1 15 0',
  ticket:
    'M4 8.5A2.5 2.5 0 0 1 6.5 6h11A2.5 2.5 0 0 1 20 8.5v1a2.5 2.5 0 0 0 0 5v1a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 15.5v-1a2.5 2.5 0 0 0 0-5v-1Zm10-1v9',
  sparkles:
    'm12 3 1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3Zm6 10 .9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9.9-2.1Z',
  cards:
    'M8.5 7h9A1.5 1.5 0 0 1 19 8.5v10a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 7 18.5v-10A1.5 1.5 0 0 1 8.5 7Zm-3 10A1.5 1.5 0 0 1 4 15.5v-10A1.5 1.5 0 0 1 5.5 4h9A1.5 1.5 0 0 1 16 5.5',
  chevronRight: 'm9.5 5.5 6.5 6.5-6.5 6.5',
  lock: 'M7 10.5V8a5 5 0 0 1 10 0v2.5M6 10.5h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1Z',
  check: 'm5 12.5 4.5 4.5L19 7',
  bolt: 'M13 3 5.5 13.5H12l-1 7.5 7.5-10.5H12l1-7.5Z',
  trophy:
    'M8 4h8v5a4 4 0 0 1-8 0V4Zm8 1.5h2.5A2.5 2.5 0 0 1 16 10M8 5.5H5.5A2.5 2.5 0 0 0 8 10m4 3v3.5m-3.5 3.5h7',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4.5V12l3 2',
  plus: 'M12 5.5v13M5.5 12h13',
  refresh: 'M20 12a8 8 0 1 1-2.4-5.7M20 4v4h-4',
  logo: 'M12 2.5 21 7v10l-9 4.5L3 17V7l9-4.5Zm0 5.5-4.5 2.2v4.6L12 17l4.5-2.2v-4.6L12 8Z',
  grid: 'M4 4h6.5v6.5H4V4Zm9.5 0H20v6.5h-6.5V4ZM4 13.5h6.5V20H4v-6.5Zm9.5 0H20V20h-6.5v-6.5Z',
  users:
    'M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7-6.9a3.5 3.5 0 0 1 0 6.8M15.5 20v-1.5a4 4 0 0 0-4-4h-5a4 4 0 0 0-4 4V20m18 0v-1.5a4 4 0 0 0-3-3.87',
  gift: 'M4.5 11.5h15V20a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-8.5Zm-1-4h17a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5ZM12 7.5V21M12 7.5S10.8 3.5 8.3 3.5a2 2 0 0 0 0 4H12Zm0 0s1.2-4 3.7-4a2 2 0 0 1 0 4H12Z',
  settings:
    'M12 9.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2Zm7.4 3.6a7.6 7.6 0 0 0 0-2l2-1.5-2-3.5-2.3 1a7.4 7.4 0 0 0-1.8-1L15 3.5h-4l-.3 2.5a7.4 7.4 0 0 0-1.8 1l-2.3-1-2 3.5 2 1.5a7.6 7.6 0 0 0 0 2l-2 1.5 2 3.5 2.3-1a7.4 7.4 0 0 0 1.8 1L11 20.5h4l.3-2.5a7.4 7.4 0 0 0 1.8-1l2.3 1 2-3.5-2-1.5Z',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm9 16-4-4',
  filter: 'M4 5h16l-6.5 7.5V19l-3 1.5v-8L4 5Z',
  arrowUp: 'M12 19.5v-15M6 10.5l6-6 6 6',
  arrowDown: 'M12 4.5v15M6 13.5l6 6 6-6',
  edit: 'M4 20h4L18.6 9.4a2 2 0 0 0-2.83-2.83L5 17.2V20ZM14.5 6.5l3 3',
  trash:
    'M5 7h14M10 7V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2m3 0v12.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V7M10 11v5.5M14 11v5.5',
  shield: 'M12 3 5 6v5c0 4.4 3 7.6 7 9 4-1.4 7-4.6 7-9V6l-7-3Z',
  dots: 'M12 6h.01M12 12h.01M12 18h.01',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  swap: 'M7 4 3 8l4 4M3 8h13M17 20l4-4-4-4M21 16H8',
  download: 'M12 4v10M8 11l4 4 4-4M5 19.5h14',
  ban: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-6.4 2.6 12.8 12.8',
  x: 'M6 6l12 12M18 6 6 18',
  grip: 'M9 6h.01M9 12h.01M9 18h.01M15 6h.01M15 12h.01M15 18h.01',
  star: 'M12 3.5l2.6 5.3 5.9.86-4.25 4.14 1 5.85L12 17.77 6.75 20.6l1-5.85L3.5 9.66l5.9-.86L12 3.5Z',
  crown: 'M4 7l3.6 3L12 5l4.4 5L20 7l-1.6 10H5.6L4 7Z',
  flame: 'M12 3s5 4 5 9a5 5 0 0 1-10 0c0-2 1-3 1-3 0 1.5 1 2 1 2 0-3 3-5 3-8Z',
  heart:
    'M12 20s-7-4.35-9.2-8.2A4.6 4.6 0 0 1 12 6.5 4.6 4.6 0 0 1 21.2 11.8C19 15.65 12 20 12 20Z',
  award: 'M12 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3.2 9L7 20.5 12 18l5 2.5L15.2 12',
  expand:
    'M9 4H5.5a1.5 1.5 0 0 0-1.5 1.5V9m11-5h3.5A1.5 1.5 0 0 1 20 5.5V9M9 20H5.5A1.5 1.5 0 0 1 4 18.5V15m11 5h3.5a1.5 1.5 0 0 0 1.5-1.5V15',
  collapse:
    'M4 9h3.5A1.5 1.5 0 0 0 9 7.5V4m11 5h-3.5A1.5 1.5 0 0 1 15 7.5V4M4 15h3.5A1.5 1.5 0 0 1 9 16.5V20m11-5h-3.5a1.5 1.5 0 0 0-1.5 1.5V20',
  // Creator emblems, worn in the wheel's hub. Drawn on the same 24 grid and in
  // the same single-stroke language as everything above, so a wheel emblem
  // never looks pasted in from another set.
  leaf: 'M19 5C19 12 12 19 5 19 5 12 12 5 19 5Zm-2 2L7.5 16.5M5 19 3 21',
  bat: 'M12 9c-.8 0-1.4.5-1.8 1.3-1.1-1.3-2.8-2-4.6-1.8.4.8.4 1.7 0 2.4-1 .1-2 .5-2.7 1.3 3.1.2 5.2 2 6.2 4.3L12 15l2.9-.5c1-2.3 3.1-4.1 6.2-4.3-.7-.8-1.7-1.2-2.7-1.3-.4-.7-.4-1.6 0-2.4-1.8-.2-3.5.5-4.6 1.8C13.4 9.5 12.8 9 12 9ZM10.6 8.6 9.9 6l1.9 1.4M13.4 8.6l.7-2.6-1.9 1.4',
  /**
   * Moonpetal — a lotus: one upright petal between two that sweep out.
   *
   * Three shapes rather than the four-of-a-kind it replaced, because a rosette
   * of equal petals turns to mush the moment it drops to the 16px a balance pill
   * gives it, while a silhouette with one tall element and two low ones stays
   * readable all the way down.
   *
   * Drawn against a base at y=19 and a tip at y=4 — half a unit **above** the
   * geometric centre of the box. A lotus carries its weight in the two lower
   * petals, so a shape centred by arithmetic reads as sinking next to a line of
   * digits. Optical centring is the whole reason those numbers are not round.
   */
  petal:
    'M12 19c-3.1-4.3-3.1-10.7 0-15 3.1 4.3 3.1 10.7 0 15ZM12 19c-4.2-.7-7.4-3.9-8.1-8.1 4.2.7 7.4 3.9 8.1 8.1ZM12 19c4.2-.7 7.4-3.9 8.1-8.1-4.2.7-7.4 3.9-8.1 8.1Z',
  /**
   * Bloodmark — a drop with the single inner arc that reads as a highlight.
   *
   * One stroke is the whole difference between a pictogram of a drop and
   * something that looks like an object with a surface. Any more detail and the
   * bulb fills in at small sizes.
   *
   * Sat at y=4.5 rather than 3.5: the original hung a unit high in its box, which
   * is invisible on its own and obvious beside a number.
   */
  droplet:
    'M12 4.5c3.2 3.6 5 6.4 5 8.7a5 5 0 0 1-10 0c0-2.3 1.8-5.1 5-8.7ZM9.7 14.3a2.3 2.3 0 0 0 2.3 2.3',
} as const;

export type IconName = keyof typeof PATHS;

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 20, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
